import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function ZipCodeRenderer({ value, onChange, readOnly }: FieldRendererProps) {
  function handleChange(raw: string) {
    // Strip non-digits, then auto-insert hyphen after position 5 for ZIP+4
    const digits = raw.replace(/\D/g, '');
    if (digits.length <= 5) {
      onChange(digits);
    } else {
      onChange(digits.slice(0, 5) + '-' + digits.slice(5, 9));
    }
  }

  return (
    <Input
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => handleChange(e.value ?? '')}
      disabled={readOnly}
      maxLength={10}
      placeholder="12345 or 12345-6789"
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'ZIP',
  label: 'Zip Code',
  category: 'formatted',
  icon: <FontAwesomeIcon icon={faLocationDot} fixedWidth />,
  defaultProps: {
    label: 'Zip Code',
    isRequired: false,
    validation: { pattern: '^\\d{5}(-\\d{4})?$' },
  },
  Renderer: ZipCodeRenderer,
};
